import type { Severity } from "../types/api";

export const SEVERITY_COLOR: Record<Severity, string> = {
  advisory: "#64748B",
  low: "#22D3EE",
  medium: "#F59E0B",
  high: "#F97316",
  critical: "#EF4444",
};

export const SEVERITY_LABEL: Record<Severity, string> = {
  advisory: "Advisory",
  low: "Low",
  medium: "Medium",
  high: "High",
  critical: "Critical",
};

export const SEVERITY_ORDER: Severity[] = ["advisory", "low", "medium", "high", "critical"];

export function severityEdgeClass(s: Severity): string {
  return `edge-${s}`;
}

export function timeAgo(iso: string): string {
  const d = new Date(iso).getTime();
  const diff = Date.now() - d;
  const s = Math.round(diff / 1000);
  if (s < 60) return `${s}s ago`;
  const m = Math.round(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.round(m / 60);
  if (h < 48) return `${h}h ago`;
  return `${Math.round(h / 24)}d ago`;
}

export function fmtTime(iso: string): string {
  return new Date(iso).toLocaleString("en-AU", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}

export function fmtAUD(n: number): string {
  if (n >= 1_000_000) return `A$${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `A$${(n / 1_000).toFixed(0)}k`;
  return `A$${n}`;
}

export function fmtNum(n: number): string {
  return n.toLocaleString("en-AU");
}

export const EMESRT_COLOR: Record<string, string> = {
  L7: "#22D3EE",
  L8: "#3B82F6",
  L9: "#F97316",
};
